export default __webpack_public_path__ + "static/a8-6c6a1c95fe55a44e9a2312fa779ff378.png";